import { render } from "./ClaimStep2.vue?vue&type=template&id=49355a50&ts=true"
import script from "./ClaimStep2.vue?vue&type=script&lang=ts"
export * from "./ClaimStep2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__